import React from 'react';
import {
  Box,
  LinearProgress,
  Typography,
  Alert,
  Button,
} from '@mui/material';
import { themeColors } from '../../utils/theme';

interface S3DownloadManagerProps {
  progress: number; // 0-100
  status: 'idle' | 'downloading' | 'compressing' | 'success' | 'error';
  message: string;
  onRetry?: () => void; // New prop for retry functionality
}

const S3DownloadManager: React.FC<S3DownloadManagerProps> = ({
  progress,
  status,
  message,
  onRetry,
}) => {
  if (status === 'idle') {
    return null;
  }

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      {status === 'error' ? (
        <Alert
          severity="error"
          action={
            onRetry && (
              <Button color="inherit" size="small" onClick={onRetry}>
                Retry
              </Button>
            )
          }
        >
          {message}
        </Alert>
      ) : status === 'success' ? (
        <Alert severity="success">{message}</Alert>
      ) : (
        <Box>
          <Typography variant="body2" color="textSecondary">{message}</Typography>
          <LinearProgress variant="determinate" value={progress} sx={{ mt: 1, '& .MuiLinearProgress-bar': { backgroundColor: themeColors.primary } }} />
          <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
            {progress.toFixed(0)}%
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default S3DownloadManager;
